import {Model} from '@vuex-orm/core';
import UnitPlanActivity from './UnitPlanActivity';
import Ie from '../objetive/Ie';

export default class UnitPlanActivityIe extends Model {
    static entity = 'unitplan_activity_ies';

    static fields () {
        return {
            id: this.number(0),
            ie_id: this.number(null),
            activity_id: this.number(null),
            disabled: this.boolean(false),
            created_at: this.string(new Date().toISOString().substr(0, 10)),
            update_at: this.string(new Date().toISOString().substr(0, 10)),

            activity: this.belongsTo(UnitPlanActivity, 'activity_id'),
            ie: this.belongsTo(Ie, 'ie_id', 'id'),
        };
    }
}
